/* ============================================================================
   olmia-variants.js — per-variant INHOUD op de productpagina.

   WAT DIT DOET (en wat het bewust NIET doet)
   ------------------------------------------
   Olmia, 18 augustus: "bij Dobot en de GRIP-onderdelen moet elke variant zijn eigen
   omschrijving en specificaties kunnen hebben, en de variantfoto's schakelen niet
   mee". Dit bestand regelt exact die drie dingen bij een variantwissel:
     1. omschrijving  → [data-variant-desc] vult zich, de productomschrijving
                        ([data-desc]) verbergt zich; geen eigen tekst = omgekeerd.
     2. specificaties → de tabel wordt opnieuw samengesteld uit de variantregels +
                        de zuivere producttabel in <template data-product-specs>.
     3. foto          → heeft de variant een eigen afbeelding, dan springt de galerij
                        daarheen (hoofdbeeld én actieve thumbnail). GEEN eigen foto =
                        de huidige foto blijft staan; terugvallen op foto 1 voelt kapot.

   PRIJZEN ZITTEN HIER NIET IN. Die blijven volledig bij olmia-product.js en het
   prijsgegate [data-product-config]. Dit bestand leest [data-variant-config], dat per
   constructie geen prijs, geen variant-id en geen beschikbaarheid bevat en dáárom ook
   achter de prijsmuur mag staan (zie snippets/product-variant-config.liquid).

   TWEE WERELDEN
   -------------
   • Prijzen zichtbaar → olmia-product.js is geladen en bezit de galerij en de
     actief-status van de knoppen. Wij schakelen de foto door de bijbehorende
     thumbnail te KLIKKEN, zodat de interne fototeller van olmia-product.js in de pas
     blijft lopen (rechtstreeks .src zetten zou hem laten verspringen bij de volgende pijl).
   • Prijzen afgeschermd → olmia-product.js is er niet. Dan was de hele PDP stil: de
     variantknoppen deden niets en de galerijpijlen ook niet. Dit bestand neemt die
     bediening dan over (zie initFallbackGallery + syncButtons).

   Editor-veilig: init(root) is idempotent en scoped; de gedelegeerde klik-listener
   hangt één keer op moduleniveau en leest de actuele modulestatus.
   ========================================================================== */
(function () {
  'use strict';
  const T = (k, f) => (window.olmiaT ? window.olmiaT(k, f) : f);

  var scopeEl = document;
  var cfg = null;                 // { variants: [ {o,img,desc,rows,mode,title} ] }
  var sel = [];                   // gekozen optiewaarde per optie-index
  var owned = false;              // true = olmia-product.js ontbreekt, wij besturen de galerij
  var bound = false;              // gedelegeerde listener één keer binden
  var galBound = null;            // de galerij waarop de fallback-listener hangt
  var galHandler = null;
  var stickyScroll = null;        // fallback voor de sticky koopbalk (zie initFallbackSticky)
  var baseAlt = '';               // originele alt van het hoofdbeeld
  var DESC_MAX = 300;             // zelfde inkortgrens als olmia-product.js

  function $(s, r) { return (r || scopeEl).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || scopeEl).querySelectorAll(s)); }

  var reduceMotion = function () {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  };

  /* ------------------------------ variant zoeken ---------------------------- */

  function sameOptions(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  function currentVariant() {
    if (!cfg || !cfg.variants) return null;
    for (var i = 0; i < cfg.variants.length; i++) {
      if (sameOptions(cfg.variants[i].o, sel)) return cfg.variants[i];
    }
    return null;
  }

  // De gekozen waarden uit de DOM lezen: dat is de enige bron die zowel met als
  // zonder olmia-product.js klopt, en na een editor-rerender meteen weer juist is.
  function readSelection() {
    var groups = $$('.variant-group');
    if (!groups.length) return cfg && cfg.variants && cfg.variants.length ? (cfg.variants[0].o || []).slice() : [];
    var out = [];
    groups.forEach(function (g) {
      var gi = +g.getAttribute('data-group') || 0;
      var active = g.querySelector('.vopt.active') || g.querySelector('.vopt');
      out[gi] = active ? active.getAttribute('data-value') : '';
    });
    return out;
  }

  /* --------------------------- knoppen bijhouden ---------------------------- */
  /* Idempotent: draait olmia-product.js óók, dan zet het exact dezelfde waarden.  */

  function syncButtons() {
    $$('.variant-group').forEach(function (g) {
      var gi = +g.getAttribute('data-group') || 0;
      var val = sel[gi];
      Array.prototype.forEach.call(g.querySelectorAll('.vopt'), function (b) {
        var on = b.getAttribute('data-value') === val;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var s = g.querySelector('.sel');
      if (s && val != null) s.textContent = val;
    });
  }

  /* ------------------------------ omschrijving ------------------------------ */

  function paintDesc(v) {
    var box = $('[data-variant-desc]');
    var prod = $('[data-desc]');
    var html = (v && v.desc) || '';
    if (box) {
      if (html) {
        box.innerHTML = html;
        clampDesc(box);
        box.hidden = false;
      } else {
        box.innerHTML = '';
        box.hidden = true;
      }
    }
    // De productomschrijving wijkt alleen als de variant er echt één heeft ÉN er een
    // element is om die tekst in te zetten. Zonder die tweede voorwaarde zou een pagina
    // zonder variantpaneel zijn omschrijving kwijtraken (gevonden door verify-varianten).
    if (prod) prod.hidden = !!(html && box);
    var title = $('[data-variant-title]');
    if (title && v && v.title) title.textContent = v.title;
  }

  // Zelfde "Lees meer"-gedrag als de productomschrijving (design product.js).
  function clampDesc(el) {
    var full = el.innerHTML;
    var text = el.textContent.trim();
    if (text.length <= DESC_MAX) return;
    var short = text.slice(0, DESC_MAX).replace(/\s+\S*$/, '');
    el.dataset.full = full;
    el.textContent = short + '… ';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'link-more';
    btn.textContent = T('product.read_more', 'Lees meer');
    btn.addEventListener('click', function () { el.innerHTML = el.dataset.full; });
    el.appendChild(btn);
  }

  /* ------------------------------ specificaties ----------------------------- */

  function rowsFromHTML(html) {
    var t = document.createElement('template');
    t.innerHTML = '<table><tbody>' + (html || '') + '</tbody></table>';
    return Array.prototype.slice.call(t.content.querySelectorAll('tr'));
  }

  // Vaste speclabels: intern Nederlands (sleutel voor het ontdubbelen), getoond in de taal van de winkel.
  // Variantregels kunnen in het Engels al vertaald zijn; canon() brengt beide vormen op dezelfde sleutel.
  var SPEC_LBL = [['Reikwijdte', T('product.spec_reach', 'Reikwijdte')], ['Gewicht', T('product.spec_weight', 'Gewicht')], ['Afmetingen', T('product.spec_dimensions', 'Afmetingen')], ['Aansluitspanning', T('product.spec_voltage', 'Aansluitspanning')], ['Snelheid', T('product.spec_speed', 'Snelheid')], ['Besturing', T('product.spec_control', 'Besturing')], ['Certificeringen', T('product.spec_certifications', 'Certificeringen')]];
  var SPEC_TOON = {}, SPEC_CANON = {};
  SPEC_LBL.forEach(function (x) { var nl = x[0].toLowerCase(); SPEC_TOON[nl] = x[1]; SPEC_CANON[x[1].toLowerCase()] = nl; });
  function canon(l) { return SPEC_CANON[l] || l; }

  function labelOf(tr) {
    var th = tr.querySelector('th');
    return th ? canon(th.textContent.trim().toLowerCase()) : '';
  }

  function toonRij(r) {
    var th = r.querySelector('th'), l = th ? th.textContent.trim().toLowerCase() : '';
    if (!SPEC_TOON[l] || SPEC_TOON[l] === th.textContent.trim()) return r.outerHTML;
    var c = r.cloneNode(true); c.querySelector('th').textContent = SPEC_TOON[l]; return c.outerHTML;
  }

  function paintSpecs(v) {
    var table = $('[data-spec-table]');
    if (!table) return;
    var tpl = $('template[data-product-specs]');
    var productRows = tpl ? Array.prototype.slice.call(tpl.content.querySelectorAll('tr')) : [];
    var variantRows = rowsFromHTML(v && v.rows);
    var rows;
    if (v && v.mode === 'vervangen' && variantRows.length) {
      rows = variantRows;
    } else {
      var seen = {};
      variantRows.forEach(function (r) { seen[labelOf(r)] = true; });
      rows = variantRows.concat(productRows.filter(function (r) { return !seen[labelOf(r)]; }));
    }
    table.innerHTML = rows.map(toonRij).join('');
    var acc = table.closest('[data-spec-acc]');
    if (!acc) return;
    acc.hidden = rows.length === 0;
    // Het omhulsel .acc draagt een bovenrand; het staat server-side op hidden zolang er
    // niets in zit (specificaties, downloads noch FAQ). Zodra deze variant regels
    // meebrengt moet het weer zichtbaar zijn — en andersom.
    var wrap = acc.closest('.acc');
    if (wrap) wrap.hidden = !wrap.querySelector('.acc__item:not([hidden])');
  }

  /* --------------------------------- galerij -------------------------------- */

  function galleryShow(gal, idx) {
    var main = gal.querySelector('#galMain');
    var thumbs = $$('.gthumb', gal);
    if (!thumbs.length || !main) return;
    var n = thumbs.length;
    var i = ((idx % n) + n) % n;
    var src = thumbs[i].getAttribute('data-src');
    if (!src) return;
    // Een srcset wint altijd van src; het serverbeeld draagt er één (image_tag).
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = src;
    thumbs.forEach(function (t) { t.classList.toggle('active', +t.getAttribute('data-i') === i); });
  }

  // Alleen actief als olmia-product.js NIET geladen is (prijsmuur): anders zou de
  // galerij twee besturingen krijgen en zou de fototeller daar uit de pas lopen.
  function initFallbackGallery() {
    var gal = $('.gallery');
    if (galBound && galHandler) { galBound.removeEventListener('click', galHandler); galBound = null; galHandler = null; }
    if (!gal || !owned) return;
    var idx = 0;
    var active = gal.querySelector('.gthumb.active');
    if (active) idx = +active.getAttribute('data-i') || 0;
    galHandler = function (e) {
      var arrow = e.target.closest ? e.target.closest('[data-gal]') : null;
      if (arrow) { idx += (+arrow.getAttribute('data-gal') || 0); galleryShow(gal, idx); return; }
      var t = e.target.closest ? e.target.closest('.gthumb') : null;
      if (t) { idx = +t.getAttribute('data-i') || 0; galleryShow(gal, idx); }
    };
    gal.addEventListener('click', galHandler);
    galBound = gal;
  }

  /* ------------------------- sticky koopbalk (fallback) --------------------- */
  /* Zelfde oorzaak als de galerij hierboven (ROADBLOCKS #22): de sticky koopbalk wordt
     door olmia-product.js aangezet, en dat bestand ontbreekt zodra de prijsmuur actief
     is. Met de gastenmuur aan is dat ELKE bezoeker op ELK product — de ontworpen balk
     verscheen dus nooit. Alleen actief als olmia-product.js er niet is; anders zou hij
     twee keer geschakeld worden. */
  function initFallbackSticky() {
    if (stickyScroll) { window.removeEventListener('scroll', stickyScroll); stickyScroll = null; }
    if (!owned) return;
    var bar = $('#stickyBuy') || document.getElementById('stickyBuy');
    var anchor = $('.pdp__buy');
    if (!bar || !anchor) return;
    stickyScroll = function () { bar.classList.toggle('show', anchor.getBoundingClientRect().bottom < 0); };
    window.addEventListener('scroll', stickyScroll, { passive: true });
    stickyScroll();
  }

  function swapPhoto(v) {
    // Geen eigen foto → laat staan wat er staat. Terugvallen op foto 1 voelt kapot.
    if (!v || typeof v.img !== 'number' || v.img < 0) return;
    var gal = $('.gallery');
    if (!gal) return;
    var thumb = gal.querySelector('.gthumb[data-i="' + v.img + '"]');
    if (!thumb) return;                     // product met één foto: niets te schakelen
    if (thumb.classList.contains('active')) return;
    var main = gal.querySelector('#galMain');
    if (main && v.title) main.alt = baseAlt ? (baseAlt + ' – ' + v.title) : v.title;

    var go = function () { thumb.click(); };   // via de thumbnail, zie kop van dit bestand
    if (!main || reduceMotion()) { go(); return; }
    gal.classList.add('is-swapping');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      clearTimeout(timer);
      main.removeEventListener('load', finish);
      gal.classList.remove('is-swapping');
    };
    var timer = setTimeout(finish, 450);
    main.addEventListener('load', finish);
    go();
  }

  /* --------------------------- vergelijkingstabel --------------------------- */

  function paintCompare() {
    var table = document.querySelector('[data-variant-compare]');
    if (!table) return;
    var key = sel.join(' / ');
    Array.prototype.forEach.call(table.querySelectorAll('[data-vcmp-row]'), function (tr) {
      if (tr.getAttribute('data-vcmp-row') === key) tr.setAttribute('data-vcmp-active', '');
      else tr.removeAttribute('data-vcmp-active');
    });
  }

  /* ------------------------------ schermlezer ------------------------------- */

  function announce(v) {
    var el = $('[data-variant-status]');
    if (!el || !v) return;
    el.textContent = T('product.variant_selected_status', 'Gekozen uitvoering: {title}').replace('{title}', function () { return v.title || sel.join(' / '); });
  }

  /* --------------------------------- toepassen ------------------------------ */

  function apply(fromUser) {
    var v = currentVariant();
    syncButtons();
    paintDesc(v);
    paintSpecs(v);
    paintCompare();
    if (fromUser) { swapPhoto(v); announce(v); }
  }

  /* ---------------------------------- init ---------------------------------- */

  function init(sectionRoot) {
    var scope = sectionRoot || document;
    var cfgEl = scope.querySelector('[data-variant-config]');
    if (!cfgEl) return;
    var parsed;
    try { parsed = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!parsed || !parsed.variants || !parsed.variants.length) return;

    scopeEl = scope;
    cfg = parsed;
    owned = !scope.querySelector('[data-product-config]');
    sel = readSelection();

    var main = scope.querySelector('#galMain');
    baseAlt = main ? (main.getAttribute('alt') || '') : '';

    initFallbackGallery();
    initFallbackSticky();

    // Bij het opstarten NIET de foto omwisselen of iets voorlezen: de server heeft de
    // juiste foto en tekst al gerenderd (init_image / v_desc in main-product.liquid).
    apply(false);

    if (!bound) {
      bound = true;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.vopt') : null;
        if (!btn || !cfg) return;
        if (scopeEl !== document && !scopeEl.contains(btn)) return;
        var gi = +btn.getAttribute('data-gi') || 0;
        sel[gi] = btn.getAttribute('data-value');
        apply(true);
      });
    }
  }

  function teardown() {
    if (galBound && galHandler) galBound.removeEventListener('click', galHandler);
    galBound = null;
    galHandler = null;
    if (stickyScroll) { window.removeEventListener('scroll', stickyScroll); stickyScroll = null; }
  }

  if (window.OlmiaEditor) {
    window.OlmiaEditor.register({
      key: 'olmia-variants',
      match: function (r) { return !!(r && r.querySelector && r.querySelector('[data-variant-config]')); },
      init: init,
      teardown: teardown
    });
  }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
})();
